import React from 'react';
import { useState, useEffect } from 'react';
import './style.css';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  Card,
  Form,
  Input,
  Button,
  Row,
  Col,
  Steps,
  Upload,
  message,
  Select,
  Space,
  Table,
  Modal,
  InputNumber,
} from 'antd';
import step_base_icon from '../../../../assets/icons/step_base_icon.png';
import barChart from '../../../../assets/icons/bar-chart-square-02.png';
import request_approval_img from '../../../../assets/icons/request_approval_img.png';
import {
  getProjectList,
  getBbsList,
  fetchProjectList,
  createNewProject,
  setApprovalView,
} from '../../redux/slice.js';
import arrow_down from '../../../../assets/icons/arrow_down.png';
import pdf_image from '../../../../assets/icons/pdf_image.png';
import button_icon from '../../../../assets/icons/button_icon.png';
import excel_icon from '../../../../assets/icons/excel_icon.png';
import chevron_down from '../../../../assets/icons/chevron_down.png';
import download_pop_icon from '../../../../assets/icons/download_pop_icon.png';
import { useSelector, useDispatch } from 'react-redux';
import { getApproverDashboard } from '../../../dashboard/redux/slice.js';
import LocalStorage from '../../../../utilities/localStorage.js';
import DashboardCreate from '../../../dashboard/components/dashboardCreate/index.js';
import { invalid } from 'moment';

const { Step } = Steps;

const RequestApproval = () => {
  const user_details = LocalStorage.getItem('bbs_user');
  console.log('user details: ', user_details);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { Option } = Select;

  const [form] = Form.useForm();
  const [formData, setFormData] = useState({});
  const [projectCode, setProjectCode] = useState(''); // Track the project code
  const [isFetched, setIsFetched] = useState(false);

  const [selectedProjectName, setSelectedProjectName] = useState('');
  const [selectedLocationName, setSelectedLocationName] = useState('');
  const [filteredProjects, setFilteredProjects] = useState([]);
  const [isSingleProjectCode, setIsSingleProjectCode] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isBackdropBlurred, setIsBackdropBlurred] = useState(false);
  const [data, setData] = useState(null);
  const [isDisabled, setIsDisabled] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [isProjectValid, setIsProjectValid] = useState(true);
  const [managerId,setManagerId]=useState(null)

  const [activeButton, setActiveButton] = useState('new'); // Default active button
  const [isApprovalView, setIsApprovalView] = useState(false);

  const handleFetchLink = () => {
    // Simulate fetching logic
    if (projectCode) {
      setIsFetched(true); // Set fetch status to true if project code is entered
    }
  };

  const location = useLocation();
  console.log('location :', location);

  const handleApprovalClick = () => {
    setIsApprovalView(true);
  };

  useEffect(() => {
    if (location.state) {
      if (location.state.isFormOpen) {
        setIsApprovalView(true);
      }
    } else {
      setIsApprovalView(false);
    }
  }, []);
  const VisualizationBar = ({ data }) => {
    const total = data.reduce((sum, item) => sum + item.value, 0); // Calculate the total value

    return (
      <div
        style={{
          display: 'flex',
          width: '100%',
          height: '36px',
          borderRadius: '20px',
          overflow: 'hidden',
        }}
      >
        {data.map((item, index) => (
          <div
            key={index}
            style={{
              backgroundColor: item.color, // Assign color for each segment
              width: `${(item.value / total) * 100}%`, // Calculate width as percentage
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              color: '#fff',
              fontSize: '12px',
              fontWeight: 'bold',
            }}
          >
            {item.value}
          </div>
        ))}
      </div>
    );
  };

  const dataSource1 = [
    {
      key: '1',
      size: 50,
      repitition: 20,
      visualizationData: [
        { label: 'A', value: 40, color: '#FFB0B0' },
        { label: 'B', value: 30, color: '#FFD09B' },
        { label: 'C', value: 30, color: '#FFECC8' },
      ],
    },
    {
      key: '1',
      size: 50,
      repitition: 20,
      visualizationData: [
        { label: 'A', value: 10, color: '#FFB0B0' },
        { label: 'B', value: 30, color: '#FFD09B' },
        { label: 'C', value: 30, color: '#FFECC8' },
      ],
    },
    {
      key: '1',
      size: 50,
      repitition: 20,
      visualizationData: [
        { label: 'A', value: 40, color: '#FFB0B0' },
        { label: 'B', value: 30, color: '#FFD09B' },
        { label: 'C', value: 30, color: '#FFECC8' },
      ],
    },
    {
      key: '2',
      size: 25,
      repitition: 32,
      visualizationData: [
        { label: 'A', value: 30, color: '#FFB0B0' },
        { label: 'B', value: 50, color: '#FFD09B' },
        { label: 'C', value: 10, color: '#FFECC8' },
        { label: 'D', value: 10, color: '#FFF7D1' },
      ],
    },
  ];

  const columns1 = [
    {
      title: 'Size (In MM)',
      dataIndex: 'size',
      key: 'size',
      width: '60px',
      ellipsis: true,
    },
    {
      title: 'Repitition',
      dataIndex: 'repitition',
      key: 'repitition',
      width: '60px',
      ellipsis: true,
    },

    {
      title: 'Cutting Pattern',
      key: 'visualization',
      width: '250px',
      ellipsis: true,
      render: (_, record) => (
        <VisualizationBar data={record.visualizationData} />
      ),
    },
  ];

  const dataSource = [
    {
      key: '1',
      projectCode: 'PA123',
      existingBBS: ['BBS001', 'BBS002', 'BBS003'],
    },
    {
      key: '2',
      projectCode: 'PB456',
      existingBBS: ['BBS004', 'BBS005'],
    },
    {
      key: '3',
      projectCode: 'PC789',
      existingBBS: ['BBS006'],
    },
  ];

  const columns = [
    {
      title: (
        <span
          style={{
            marginLeft: '7px',
            color: '#667085',
            fontFamily: "'SF Pro Text', sans-serif",
            fontWeight: '500',
            fontSize: '12px',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          Project Name and Code
          {/* <img
            src={arrow_down}
            alt="icon"
            style={{ marginLeft: '5px', width: '16px', height: '16px' }}
          /> */}
        </span>
      ),
      dataIndex: 'Project', // The array in bbsList
      key: 'projectCode',

      ellipsis: true,
      render: (_, record) => (
        <div>
          <a
            href={`/projects/${record.projectCode}`}
            style={{
              color: '#1890ff',
              textDecoration: 'underline',
              marginLeft: '7px',
            }}
          >
            {record.projectCode}
          </a>
        </div>
      ),
    },
    {
      title: (
        <span
          style={{
            color: '#667085',
            fontFamily: "'SF Pro Text', sans-serif",
            fontWeight: '500',
            fontSize: '12px',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          Existing BBS
          <img
            src={chevron_down}
            alt="icon"
            style={{ marginLeft: '5px', width: '16px', height: '16px' }}
          />
        </span>
      ),
      dataIndex: 'existingBBS',
      key: 'existingBBS',

      ellipsis: true,
      render: (bbsList) => (
        <div>
          {bbsList.map((bbs, index) => (
            <div key={index}>
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  setIsModalVisible(true);
                  setIsBackdropBlurred(true);
                }}
                style={{
                  color: '#1890ff',
                  textDecoration: 'underline',
                  marginBottom: '7px',
                  display: 'inline-block',
                }}
              >
                {bbs}
              </a>
            </div>
          ))}
        </div>
      ),
    },
    {
      title: (
        <span
          style={{
            marginLeft: '7px',
            color: '#667085',
            fontFamily: "'SF Pro Text', sans-serif",
            fontWeight: '500',
            fontSize: '12px',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          Tonnage (In Tons)
        </span>
      ),
      dataIndex: 'Project', // The array in bbsList
      key: 'projectCode',
      ellipsis: true,
      render: (_, record) => (
        <div className="text-[#667085] text-[12px] font-['SF-Pro-Text-Regular, sans-serif'] ml-[8px]">
          {record.projectCode}
        </div>
      ),
    },
    {
      title: (
        <span
          style={{
            marginLeft: '7px',
            color: '#667085',
            fontFamily: "'SF Pro Text', sans-serif",
            fontWeight: '500',
            fontSize: '12px',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          Wastage (%)
        </span>
      ),
      dataIndex: 'Project', // The array in bbsList
      key: 'projectCode',
      ellipsis: true,
      render: (_, record) => (
        <div className="text-[#667085] text-[12px] font-['SF-Pro-Text-Regular, sans-serif'] ml-[8px]">
          {record.projectCode}
        </div>
      ),
    },
    {
      title: (
        <span
          style={{
            marginLeft: '7px',
            color: '#667085',
            fontFamily: "'SF Pro Text', sans-serif",
            fontWeight: '500',
            fontSize: '12px',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          Optimization By
        </span>
      ),
      dataIndex: 'Project', // The array in bbsList
      key: 'projectCode',
      ellipsis: true,
      render: (_, record) => (
        <div className="text-[#667085] text-[12px] font-['SF-Pro-Text-Regular, sans-serif'] ml-[8px]">
          {record.projectCode}
        </div>
      ),
    },
    {
      title: (
        <span
          style={{
            marginLeft: '7px',
            color: '#667085',
            fontFamily: "'SF Pro Text', sans-serif",
            fontWeight: '500',
            fontSize: '12px',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          Optimization Date
        </span>
      ),
      dataIndex: 'Project', // The array in bbsList
      key: 'projectCode',
      ellipsis: true,
      render: (_, record) => (
        <div className="text-[#667085] text-[12px] font-['SF-Pro-Text-Regular, sans-serif'] ml-[8px]">
          {record.projectCode}
        </div>
      ),
    },
    {
      title: '', // No header for this column
      key: 'action',
      render: () => (
        <Button
          onClick={() => navigate('/bbs-optimization')}
          type="primary"
          style={{
            backgroundColor: '#1C4E9D',
            borderRadius: '8px',
            text: '#FFFFFF',
            fontSize: '12px',
            padding: '8px 16px',
          }}
        >
          Optimize BBS
        </Button>
      ),
    },
  ];

  const handleCancel = () => {
    setIsModalVisible(false);
    setIsBackdropBlurred(false);
  };

  const handleConfirm = () => {
    setIsModalVisible(false);
    setIsBackdropBlurred(false);
    // Add your download logic here
    console.log('Download Confirmed');
  };

  const handleButtonClick = (buttonType) => {};

  const handleProjectNameChange = (value) => {
    const matchingProjects = allProjectList.filter(
      (item) => item.project_name === value,
    );

    console.log('Matching Projects:', matchingProjects);

    if (matchingProjects.length === 1) {
      form.setFieldsValue({ project_id: matchingProjects[0].id });
      setIsSingleProjectCode(true);
    } else {
      form.setFieldsValue({ project_id: undefined });
      setIsSingleProjectCode(false);
    }

    setSelectedProjectName(value);
    setFilteredProjects(matchingProjects);
  };

  const [currentStep, setCurrentStep] = useState(0);
  const [search, setSearch] = useState();
  const [isInvalid, setIsInvalid] = useState(false);

  const { bbsList, allProjectList, loading } = useSelector(
    (state) => state.requestApproval,
  );
  useEffect(() => {
    dispatch(getProjectList());
    dispatch(getBbsList());
  }, [dispatch]);

  const [disabledFields, setDisabledFields] = useState([]);
  const [isFetching, setIsFetching] = useState(false);
  const [projectType, setProjectType] = useState('new');
  const handleFetch = () => {
    if (projectCode) {
      setIsFetched(true);
      setIsFetching(true);
      setIsInvalid(false);
    }
    form
      .validateFields()
      .then((values) => {
        const payload = {
          userId: user_details?.user?.id,
          project_code: values?.project_code, // Use the entered project_code
        };

        // Simulated API call (replace with your actual dispatch logic)
        dispatch(fetchProjectList(payload))
          .then((response) => {
            const fetchedData = response?.payload?.details;
            setManagerId(fetchedData?.manager_id)
            console.log('Fetched Data:', fetchedData); // Log the fetched data for verification

            if (response?.payload?.success) {
              setData(fetchedData);
              setIsSuccess(true);
              if (
                response?.payload?.message ===
                'Project is already approved. Please check  \"Existing Project\" tab'
              ) {
                setIsDisabled(true);
                setProjectType('existing');
                message.error(response?.payload?.message);
                // Disable all fields if the project is existing
              } else if (
                response?.payload?.message ===
                'Project details fetched successfully! Enter other details to proceed.'
              ) {
                setIsDisabled(false);
                setProjectType('new');
                //setIsDisabled(false)
                message.success(response?.payload?.message);
                setDisabledFields(['project_name', 'bu', 'sbu', 'sbg']);
                // Disable only certain fields if the project is not existing
              } else {
                setIsDisabled(true);
              }

              // Dynamically update form fields with fetched data
              form.setFieldsValue({
                project_name: fetchedData?.project_name || '',
                bu: fetchedData?.bu || '',
                sbu: fetchedData?.sbu || '',
                sbg: fetchedData?.sbg || '',
                quantity: fetchedData?.quantity || '',
                wastagePer: fetchedData?.wastagePer || '',
                role: fetchedData?.role || undefined,
                //remarks: fetchedData?.remarks || "",
              });

              console.log('Form values set:', fetchedData);

              getApproverDashboard();
            } else {
              //message.error(response?.message?.error)
              //setIsDisabled(true);
              setIsInvalid(true);
              setIsFetched(false);
              setIsFetching(false);
              
             // setIsInvalid(false);
              console.log('error occured');
              form.setFieldsValue({
                project_name: fetchedData?.project_name || '',
                bu: fetchedData?.bu || '',
                sbu: fetchedData?.sbu || '',
                sbg: fetchedData?.sbg || '',
                quantity: fetchedData?.quantity || '',
                wastagePer: fetchedData?.wastagePer || '',
                role: fetchedData?.role || undefined,
                //remarks: fetchedData?.remarks || "",
              });
              message.error(response?.payload?.message);
            }
          })
          .catch((error) => {
            //setIsFetching(false);

            console.error('API call failed:', error);
            message.error('Failed to fetch the data.');
          });
      })
      .catch((info) => {
        console.log('Validation failed:', info);
      });
  };
  useEffect(() => {
    if (data) {
      form.setFieldsValue({
        project_name: data?.project_name || '',
        bu: data?.bu || '',
        sbu: data?.sbu || '',
        sbg: data?.sbg || '',
        quantity: data?.quantity || '',
        wastagePer: data?.wastagePer || '',
        role: data?.role || undefined,
        //remarks: data?.remarks || "",
      });
    }
  }, [data, form]);

  useEffect(() => {
    console.log('Updated projectType:', projectType);
  }, [projectType]);

  // console.log("All Project list: ", allProjectList, "Type:", Array.isArray(allProjectList))
  // console.log("All Location list: ", locations, "Type:", Array.isArray(locations))
  // console.log("All bbs list: ", bbsList, "Type:", Array.isArray(bbsList))

  const handleSearch = (e) => {
    setSearch(e);
  };

  const onSubmit = () => {
    form
      .validateFields()
      .then((values) => {
        const params = {
          type: projectType, // Make sure you're using the correct state variable here
        };
        const remarksKey =
          projectType === 'existing'
            ? 'manager_user_remarks'
            : 'manager_project_remarks';

        const payload = {
          userId: user_details?.user?.id,
          manager_id:managerId,
          project_code: values?.project_code,
          project_name: values?.project_name,
          sbg: values?.sbg,
          sbu: values?.sbu,
          bu: values?.bu,
          quantity: values?.quantity,
          wastagePer: values?.wastagePer,
          role: values?.role,
          [remarksKey]: values?.remarks,
        };

        console.log('Payload:', payload);
        dispatch(createNewProject({ payload, type: params.type }))
          .then((response) => {
            if (response?.payload?.success) {
              message.success(response?.payload?.message);
              navigate('/dashboard');
            } else {
              message.error(response?.payload?.message);
            }
          })
          .catch((error) => {
            console.error('API call failed:', error);
            message.error('Failed to submit the form.');
          });
      })
      .catch((info) => {
        console.log('Validation failed:', info);
      });
  };
  const nextStep = () => {
    form
      .validateFields()
      .then((values) => {
        setFormData((prevData) => {
          const updatedData = { ...prevData, ...values };
          console.log('Updated data:', updatedData);
          return updatedData;
        });
        message.success('Form submitted successfully!');
        navigate('/dashboard');
      })
      .catch((info) => {
        console.log('Validation failed:', info);
      });
  };

  const clearform = () => {
    form.resetFields();
    setIsFetched(false);
    setIsFetching(false);
  };

  const [isProjectExisting, setIsProjectExisting] = useState(false); // To track if the project exists or not
  const title = isSuccess && isDisabled ? 'User Request' : 'Project Request';

  const steps = [
    {
      title: <div className="step-title">{title}</div>,
      content: (
        <Form
          form={form}
          layout="vertical"
          initialValues={{
            project_code: '', // Initial empty project code
            project_name: '', // Initial empty values
            bu: '',
            sbu: '',
            sbg: '',
            quantity: '',
            wastagePer: '',
            //role: "",
            // remarks: "",
          }}
        >
          <Row gutter={24}>
            <Col span={12} sm={12} xs={24}>
              <Row gutter={12} align="middle">
                {/* Input field for Project Code */}
                <Col span={9} xs={20} sm={18} lg={20}>
                  <Form.Item label="Project Code" name="project_code">
                    <Input
                      placeholder="Enter project code"
                      value={projectCode}
                      onChange={(e) => setProjectCode(e.target.value)}
                    />
                  </Form.Item>
                </Col>
                {/* Fetch link */}
                <Col span={4} xs={4} sm={3} lg={4}>
                  <Button
                    onClick={handleFetch}
                    className="fetch-link"
                    disabled={isFetching}
                    loading={loading}
                  >
                    Fetch
                  </Button>
                </Col>
              </Row>
            </Col>

            {/* Dynamically disabled fields */}
            <Col span={12} xs={24} sm={12}>
              <Form.Item label="Project Name" name="project_name">
                <Input
                  placeholder="Enter project name"
                  disabled={
                    isDisabled || disabledFields.includes('project_name')
                  }
                />
              </Form.Item>
            </Col>
            <Col span={12} xs={24} sm={12}>
              <Form.Item label="SBG" name="sbg">
                <Input
                  placeholder="SBG"
                  disabled={isDisabled || disabledFields.includes('sbg')}
                />
              </Form.Item>
            </Col>

            <Col span={12} xs={24} sm={12}>
              <Form.Item label="SBU" name="sbu">
                <Input
                  placeholder="SBU"
                  disabled={isDisabled || disabledFields.includes('sbu')}
                />
              </Form.Item>
            </Col>
            <Col span={12} xs={24} sm={12}>
              <Form.Item label="BU" name="bu">
                <Input
                  placeholder="BU"
                  disabled={isDisabled || disabledFields.includes('bu')}
                />
              </Form.Item>
            </Col>

            {/* Dynamically enabled/disabled fields based on project status */}
            <Col span={12} xs={24} sm={12}>
              <Form.Item
                label="Total Reinforcement Quantity (in MT)"
                name="quantity"
                rules={[
                  {
                    validator: (_, value) => {
                      if (value && isNaN(value)) {
                        return Promise.reject(
                          new Error('Only numbers are allowed!'),
                        );
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <Input
                  placeholder="Enter total reinforcement quantity (in MT)"
                  disabled={isDisabled && isSuccess}
                  onChange={(e) => {
                    const value = e.target.value;
                    // Check if the input is a valid number (only digits allowed)
                    if (/^\d*$/.test(value)) {
                      form.setFieldsValue({ quantity: value }); // Update field value only if valid
                    }
                  }}
                />
              </Form.Item>
            </Col>

            <Col span={12} xs={24} sm={12}>
              <Form.Item
                label="Budgeted Wastage in PET/CB/CTC* (in %)"
                name="wastagePer"
                rules={[
                  {
                    validator: (_, value) => {
                      if (value && isNaN(value)) {
                        return Promise.reject(
                          new Error('Only numbers are allowed!'),
                        );
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <Input
                  placeholder="Enter budgeted wastage"
                  disabled={isDisabled && isSuccess}
                  onChange={(e) => {
                    const value = e.target.value;
                    // Check if the input is a valid number (only digits allowed)
                    if (/^\d*$/.test(value)) {
                      form.setFieldsValue({ wastagePer: value }); // Update field value only if valid
                    }
                  }}
                />
              </Form.Item>
            </Col>

            <Col span={12} xs={24} sm={12}>
              <Form.Item label="Role of Employee" name="role">
                <Select
                  placeholder="Select role of the employee"
                  disabled={isDisabled && isSuccess}
                >
                  <Option value="Planning Engineer">Planning Engineer</Option>
                  <Option value="Site Supervision">Site Supervision</Option>
                  <Option value="Project Management">Project Management</Option>
                  <Option value="Technical Expertise">
                    Technical Expertise
                  </Option>
                  <Option value="Design and Planning">
                    Design and Planning
                  </Option>
                   <Option value="BBS Engineer">
                    BBS Engineer
                  </Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={24} xs={24} sm={24}>
              <Form.Item label="Remarks" name="remarks">
                <Input.TextArea placeholder="Enter remarks" />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      ),
    },
  ];
  useEffect(() => {
    if (isSuccess && isDisabled) {
      setActiveButton('existing');
    } else if (isSuccess) {
      setActiveButton('new');
    }
  }, [isSuccess, isDisabled]);

  return (
    bbsList &&
    allProjectList && (
      <div className="main-div">
        <div className="flex items-center gap-2 mt-4 ml-8 barchart-text">
          <img src={request_approval_img} alt="Bar Chart" />
          <div className="flex gap-[8px]">
            <button
              className={`bg-[#1C4E9D] text-[#FFFFFF] font-['SF-Pro-Text-Regular, sans-serif'] font-semibold text-[13px] px-4 py-2 ${
                activeButton === 'new'
                  ? 'opacity-100 cursor-pointer'
                  : 'opacity-50'
              }`}
              onClick={() => handleButtonClick('new')}
            >
              New Project
            </button>
            <button
              className={`bg-[#1C4E9D] text-[#FFFFFF] font-['SF-Pro-Text-Regular, sans-serif'] font-semibold text-[13px] px-4 py-2 ${
                activeButton === 'existing'
                  ? 'opacity-100 cursor-pointer'
                  : 'opacity-50'
              }`}
            >
              Existing Project
            </button>
          </div>
        </div>

        <div className="steps_parent_bbs">
          <Steps
            className="steps_track_bbs"
            style={{ width: 'auto' }}
            current={currentStep}
            labelPlacement="vertical"
          >
            {steps.map((item, index) => (
              <Step
                key={index}
                icon={
                  <img
                    src={step_base_icon}
                    alt="Step Icon"
                    className="step-icon"
                  />
                }
                title={
                  <div className="flex flex-col step-title-container">
                    <div className="text-sm font-semibold text-blue-800 step-title">
                      {item.title}
                    </div>
                  </div>
                }
              />
            ))}
          </Steps>
        </div>

        <div className="flex items-center justify-center step-card">
          <div className="steps_content_parent">
            <Card>
              <div className="steps-content">
                {steps[currentStep]?.content || <div>No content available</div>}
              </div>
              <div className="mt-4 text-center steps-action">
                {currentStep === 0 && (
                  <>
                    <Button
                      style={{ margin: '0 8px' }}
                      onClick={clearform}
                      className="px-4 py-2 text-blue-800 bg-white rounded-lg prev-button"
                    >
                      Clear
                    </Button>
                    <Button
                      type="primary"
                      onClick={onSubmit}
                      loading={loading}
                      className="px-4 py-2 text-white bg-blue-800 rounded-lg next-button"
                      disabled={!isFetched || !projectCode || isInvalid}
                    >
                      Submit
                    </Button>
                  </>
                )}
              </div>
            </Card>
          </div>
        </div>
      </div>
    )
  );
};

export default RequestApproval;
